import { fabric } from "fabric";

export const TaskMapPin = (canvas, x, y, worksiteTask = null, crossOrigin = 'Anonymous') => {
  const pinSvgUrl = "/taskmappin.svg";
  const svgWidth = 80;
  const desiredWidthPercentage = 0.07; 

  fabric.loadSVGFromURL(
    pinSvgUrl,
    (objects, options) => {
      // get scale taking into account the scale / zoom of the canvas
      const scale = (1/canvas.getZoom() * desiredWidthPercentage * canvas.width) / svgWidth;
      const pin = fabric.util.groupSVGElements(objects, options);
      
      // disable stretching the pin
      pin.setControlsVisibility({
        mt: false,
        mb: false,
        ml: false,
        mr: false,
      });

      pin.scale(scale).set({
        name: "pin",
        padding: 5,
        opacity: 1,
        // Update the position of the pin
        left: x - pin.getScaledWidth() / 2,
        top: y - pin.getScaledHeight(),
      });
      // set pin z index on top of all others
      pin.moveTo(1000);

      pin.setCoords(); // Calculate the SVG's dimensions

      canvas.on("object:removed", (e) => {
        if (e.target.name === "pin") {
          removePin(canvas, e.target);
        }
      });

      canvas.add(pin);
      canvas.renderAll();
    },
    null,
    {crossOrigin}
  );
};

const removePin = (canvas, target) => {
  canvas.getObjects().forEach((obj) => {
    if ((obj.name === "pin") && obj !== target) {
      canvas.remove(obj);
    }
  });
};

export default TaskMapPin;
